import HttpClient from '@/services/http-client'

class EnergyTypeService extends HttpClient {
  async show(id) {
    return this.rest.get('/v1/energy-types/' + id)
  }

  async list(page = 1, limit = 1000, text = null) {
    return this.rest.get('/v1/energy-types', {
      params: {
        page,
        limit,
        q: text
      }
    })
  }

  async create(payload) {
    return this.rest.post('/v1/energy-types', payload)
  }

  async update(payload) {
    return this.rest.patch('/v1/energy-types/' + payload.id, payload)
  }

  async delete(id) {
    return this.rest.delete('/v1/energy-types/' + id)
  }
}

export default () => new EnergyTypeService()
